export default __webpack_public_path__ + "static/media/grid.018.ae864f79.jpeg";